import { Routes, Route } from 'react-router-dom';
import { AppProviders } from '@/app/providers/AppProviders';
import { APP_ROUTES } from '@/app/router/routes';
import '@/App.css';
import '@/styles/Login.css';

function App() {
  return (
    <AppProviders>
      <Routes>
        {APP_ROUTES.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Routes>
    </AppProviders>
  );
}

export default App;
